<div class="invited-user">
  <div class="invited-user__detail">
    <procure-tag [user]="invitedUser.userModel">
      {{ invitedUser.userModel.name }}
    </procure-tag>
    <span class="invited-user__role">
      {{ invitedUser.invitationType }}
    </span>
  </div>
  @if (canRemove) {
    <button
      class="invited-user__remove"
      procure-button
      variant="stroked"
      [loading]="isRemoving()"
      (click)="removeUser()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }
</div>
